/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Ship_Ammo_RapidInputs */

const ja_calendar_ship_ammo_rapid = /** @type {(inputs: Calendar_Ship_Ammo_RapidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラピッド`)
};

const en_calendar_ship_ammo_rapid = /** @type {(inputs: Calendar_Ship_Ammo_RapidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAPID`)
};

/**
* | output |
* | --- |
* | "RAPID" |
*
* @param {Calendar_Ship_Ammo_RapidInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_ship_ammo_rapid = /** @type {((inputs?: Calendar_Ship_Ammo_RapidInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Ship_Ammo_RapidInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_calendar_ship_ammo_rapid(inputs)
	return en_calendar_ship_ammo_rapid(inputs)
});